"use client";

import cx from "classnames";
import styles from "./styles.module.scss";
import { Theme } from "@/constants/enums";

interface ShimmerType {
    width?: string;
    height?: string;
    className?: string;
    theme?: Theme;
}

const Shimmer = (props: ShimmerType) => {
    const {
        width = "100%",
        height = "100px",
        className,
        theme = Theme.LIGHT,
    } = props;

    return (
        <div
            className={cx(styles["shimmer-wrapper"], className)}
            style={{ width, height }}
            data-theme={theme}
        >
            <div className={styles["shimmer-effect"]} data-theme={theme} />
        </div>
    );
};

export default Shimmer;
